import React from 'react';

import {SimpleGallery} from './simpleGallery';
import AddToCartButton from '../addToCartButton';
import SimpleShippingInformation from './simpleShippingInformation';
import {
  calculateShippingInformation,
  getGrossPriceString,
  isProductInSale,
} from '../../lib/utils/productUtils';
import ContainedButton from '../buttons/containedButton';
import {useRouter} from 'next/router';
import {EmblaGallery} from './EmblaGallery';

export default function SimpleProduct({item, priority}) {

  const {push, asPath} = useRouter();

  const {simpleProduct} = item;
  const {simpleProductInformation, price, hasSinglePage, slug} = simpleProduct;

  let shippingInformation = calculateShippingInformation(
      simpleProduct.stocks);

  let galleryUrls = [];

  galleryUrls.push(simpleProductInformation.mainImage);
  galleryUrls = galleryUrls.concat(simpleProductInformation.gallery);

  let minPrice = price.netPrice;
  const taxInPercent = price.tax.taxPercent;
  const currency = price.currency;
  const currencyOnRight = true;

  const inSale = isProductInSale(simpleProduct);
  let salePrice;

  const priceString = getGrossPriceString(minPrice, taxInPercent, currency,
      currencyOnRight);

  if (inSale && price.salePrice != null)
    salePrice = price.salePrice;

  const salePriceString = getGrossPriceString(salePrice, taxInPercent,
      currency, currencyOnRight);

  const handleOnClickMoreAbout = async (e) => {

    e.preventDefault();

    await push(`${asPath}/product/${slug}`);

  };

  return (
      <div key={item.simpleProduct.id}
           className="w-full flex flex-col gap-5 items-center border-b pb-8 md:border-0 md:pb-0">

        <div className={'w-72 b-72 bg-gray-800'}/>
        <EmblaGallery priority={priority} lazy={true} pictures={galleryUrls} width={'w-72'}
                      height={'h-72'} showThumbnails={false}/>
        <h2 className={'font-title uppercase text-black text-center h-8'}>{item.simpleProduct.shortTitle}</h2>

        <p className={''}>
          {inSale ?
              <p>
                <del>{priceString}</del>
                <span>{salePriceString}</span></p> :
              <span>{priceString}</span>}
        </p>
        <center>
          <SimpleShippingInformation stockInformation={shippingInformation}
                                     showShippingDays={true}/>
        </center>

        {!!hasSinglePage ?
            <ContainedButton size={'sm'} onClick={handleOnClickMoreAbout}> Mehr
              dazu </ContainedButton> :
            <AddToCartButton simpleProducts={[simpleProduct]}/>}


      </div>
  );
}